import {IconButton, Menu, MenuItem} from '@mui/material'
import React, {useCallback, useState} from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Job} from '@/generated/graphql'
import CancelJobButton from '@/components/pages/JobsPage/CancelJobButton'

type DatasetJobTableItemActionsProps = {
    datasetJob: Job;
    onShowFilter: (datasetJob: Job) => void;
}

const DatasetJobTableItemActions = ({
    datasetJob,
    onShowFilter,
}: DatasetJobTableItemActionsProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const showFilter = useCallback(() => {
        if (onShowFilter) {
            onShowFilter(datasetJob)
        }

        handleClose()
    }, [datasetJob, onShowFilter])

    return (
        <>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon/>
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <MenuItem onClick={showFilter}>Show applied filter</MenuItem>
                <CancelJobButton job={datasetJob} type='dataset' variant='menuItem' onClick={handleClose} />
            </Menu>
        </>
    )
}

export default DatasetJobTableItemActions